import { useSelector } from 'react-redux'

import QuestionItem from 'app/components/QuestionItem'

const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts
const getCurrentFaq = ({ widgetData }) => widgetData.widgetInfo.helpTabCurrentFaq

function FAQDetail() {
  const texts = useSelector(getTexts)
  const currentFaq = useSelector(getCurrentFaq)
  const faqQuestionsCount = currentFaq.questions.length

  const getSortedQuestions = (array = []) => {
    // sort questions in decending order
    const sortedArray = array.sort((a, b) => {
      if (a.order > b.order) return 1
      if (a.order < b.order) return -1
      return 0
    })
    return sortedArray
  }

  return (
    <>
      {/* each faq: */}
      {/* faq detail and listing questions */}
      <div className="help_tab_body_faq_detail">
        <div className="help_tab_body_faq_detail_heading">
          <p className="help_tab_body_faq_detail_heading_title">{currentFaq.title}</p>
          <p className="help_tab_body_faq_detail_heading_description">{currentFaq.description}</p>
          {faqQuestionsCount !== 0 && (
            <p className="help_tab_body_faq_detail_heading_question_count">
              {texts.faqListCount?.replace('#count#', faqQuestionsCount)}
            </p>
          )}
        </div>
        <div className="help_tab_body_faq_question_list">
          {getSortedQuestions(currentFaq.questions).map((q, i) => {
            return (
              <div key={i} className="help_tab_body_faq_question_list_item_container">
                <QuestionItem question={q} />
              </div>
            )
          })}
          {faqQuestionsCount === 0 && (
            <div className="help_tab_body_faq_question_list_not_found">{texts.questionNotFound}</div>
          )}
        </div>
      </div>
    </>
  )
}

export default FAQDetail
